import { useEffect } from 'react';
import { initLenis, destroyLenis } from '../lib/lenis';

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    initLenis();
    return () => destroyLenis();
  }, []);

  return null;
};

export default SmoothScroll;
